export const LINK_PARAMS_MAP: Record<string, string> = {
  mediaSource: 'pid',
  webDp: 'af_web_dp',
  campaign: 'c',
  campaignId: 'af_c_id',
  retargeting: 'is_retargeting',
  iosUrl: 'af_ios_url',
  androidUrl: 'af_android_url',
  utmSource: 'utm_source',
  utmMedium: 'utm_medium',
  utmCampaign: 'utm_campaign',
  utmContent: 'utm_content',
  deepLink: 'deep_link_value',
  qr: 'af_qr',
  utm_source: 'c',
  utm_medium: 'af_adset',
  utm_campaign: 'af_ad',
  experience: 'af_xp',
};

export const EMAIL_VALIDATION_ERROR = 'Please enter a valid email';
export const PASSWORD_VALIDATION_ERROR = 'Please enter a valid password';

export const RECURLY_KEY = process.env.REACT_APP_RECURLY_KEY || '';

export const LIVEN_ANSWERS_MAP: Record<string, string> = {
  low_energy: 'Low energy',
  worry: 'Worry',
  emotional_exhaustion: 'Personal reason',
  overthinking: 'Overthinking',
  irritability: 'Irritability',
  totaly_fine: 'Overthinking',
  family: 'Family or relationship',
  circumstances: 'External',
  appearance: 'Appearance',
  sleep_issue: 'Sleep',
  job_stress: 'Job-related stress',
  other: 'External',
  '0_2_hours': 'Low',
  '3_5_hours': 'Low',
  '6_8_hours': 'Medium',
  more_than_8_hours: 'Medium',
  few_weeks_ago: 'Few weeks',
  less_year_ago: 'Last year',
  more_year_ago: 'Few years',
  never: 'Always',
  strongly_agree: 'LOW',
  somewhat_agree: 'LOW',
  somewhat_disagree: 'Medium',
  strongly_disagree: 'Medium',
  late: 'Being late/running out of time',
  money: 'Financial struggles',
  self_doubt: 'Social media',
  rarely: 'None of the above',
  few_months: 'The last few months',
  few_years: 'A few years',
  whole_life: 'My whole life',
  not_sure: "I'm not sure",
};
